<template>
  <div class="motor-recommendations" :class="device">
    <motor-list @openModal="$emit('openModal')"></motor-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MotorList from '@/components/motor/components/MotorList';

export default {
  name: 'MotorRecommendations',

  components: {
    MotorList,
  },

  data() {
    return {
      showMore: false,
    };
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
    }),
  },
};
</script>

<style lang="scss">
.motor-recommendations {
  background-color: #F5F5F5;
  grid-row-start: 3;
  grid-row-end: 4;
  grid-column-start: 2;
  grid-column-end: 3;
  margin-bottom: 20px;
  position: relative;

  &.mobile {
    grid-column-start: 1;
    grid-column-end: 3;
    max-width: calc(100vw - 30px);
    overflow-y: scroll;
  }
}
</style>